import { render, staticRenderFns } from "./FormatObjectPropertyEditor.vue?vue&type=template&id=07a0c688&scoped=true&"
import script from "./FormatObjectPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./FormatObjectPropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormatObjectPropertyEditor.vue?vue&type=style&index=0&id=07a0c688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a0c688",
  null
  
)

export default component.exports